import React, {Component} from 'react';
import FaDollar from 'react-icons/lib/fa/dollar';
import MDShoppingCart from 'react-icons/lib/md/shopping-cart';
import FaSpinner from 'react-icons/lib/fa/spinner';
import FaCheck from 'react-icons/lib/fa/check';
import FaTrash from 'react-icons/lib/fa/trash';
import { Modal  } from 'react-bootstrap';
import config from  '../../config';
import moment from 'moment'
import _ from 'lodash'
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import { getFieldByPathFormatter} from 'util/Utils';
import {Timeline, TimelineEvent} from 'react-event-timeline'
var changeLogWebhookMap = {
    'update' : 'Shopify Update',
    'delete' : 'Shopify Product Delete',
    'order_refund' : 'Shopify Order Refund',
    'order_creation' : 'Shopify Order Creation',
    'order_fulfillment' : 'Shopify',
    'fulfillment_creation' : 'Shopify',
    'order_payment' : 'Order Payment  Shopify',
    'order_cancellation' : 'Shopify Order Cancellation',
    'delete_webhook' : 'Shopify Product Delete'
}

export default class HistoryDataModal extends React.Component {
    constructor(props) {
        super(props);
         this.state = {...this.props};
    }
    componentWillReceiveProps(nextProps) {
         if (nextProps.show !== this.state.show) {
            this.setState({...nextProps})
        }

    }
    hideModal(){
        this.setState({show:false, data:{}})
    }

    render() {
         var records = this.state.data[this.state.data.currentField] ? _.reverse(this.state.data[this.state.data.currentField]) : [];
           return (
            <Modal
                show={this.state.show}
                dialogClassName="record-details-modal"
                 onHide={this.props.hideModal}
             >
                 <Modal.Header closeButton>
                    <Modal.Title>{ _.get(this.state.data, 'modalTitle',_.startCase(this.state.data.currentField)) }</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{height:400, overflow:'scroll' }}>
                    { _.includes(['Notifications', 'ChangeLog'], this.state.data.currentField) &&
                    <div>
                        {_.map(records, (record, index) => {
                             if (record.ActionType == 'received' && _.includes(['1', '2', '3', '4'], _.get(record, 'Message'))) {
                                record.Message = record.Message + ' - ' + config.buyerResponseToTextMap[record.Message].userMessage

                            }
                            var symbol = '', pict;
                            //console.log('record', record);
                            if (record.FieldChanged == 'Price' || record.FieldChanged == 'PayoutAmount') {
                                pict = <FaDollar className="text-center"></FaDollar>
                                symbol = '$'
                            } else if (record.FieldChanged == 'Status') {
                                if (record.To == 'Sold') {
                                    pict = <MDShoppingCart className="text-center"></MDShoppingCart>
                                } else if (record.To == 'Pending') {
                                    pict = <FaSpinner className="text-center"></FaSpinner>
                                } else if (record.To == 'Paid') {
                                    pict = <FaCheck className="text-center"></FaCheck>

                                }
                            } else if (record.FieldChanged == 'Deleted') {
                                if (record.To == 'true') {
                                    pict = <FaTrash className="text-center"></FaTrash>
                                } else {
                                    pict = <FaSpinner className="text-center"></FaSpinner>
                                }
                            }

                            return ( <Timeline key={index}>
                                <TimelineEvent contentStyle={{marginTop: 0, marginBottom: 0}}
                                               iconStyle={{marginLeft: 2, fontSize: 15}} title={''}
                                               createdAt={moment(_.get(record, 'Date', record.createdAt)).format("MM-DD-YYYY HH:mm")} /* Date is used in ChangeLog, while createdAt in Notifications */
                                               icon={pict}>
                                    {/*Notifications fields*/}
                                    {record.ActionType &&
                                    <div className="text-bold">{  _.startCase(record.ActionType)}</div>
                                    }
                                    {record.ActionType == 'sent' &&
                                    <div> {   'Message sent: '} <span className="text-bold">{record.Message}</span>
                                    </div>
                                    }
                                    {record.ActionType == 'received' &&
                                    <div>
                                    <span>
                                    {   'Answer received: '} <span className="text-bold">{record.Message}</span>
                                    </span>

                                    </div>
                                    }


                                    {record.By == 'admin' &&
                                    <div
                                        className="green bold-text bot5">{record.AdminFirstName ? record.AdminFirstName : 'Administrator' }</div>
                                    }
                                    {(record.By == 'scheduler' || record.By == 'server') &&
                                    <div>
                                        <div className="green bold-text bot5">Automatic task</div>
                                    </div>
                                    }
                                    {record.By == 'user' &&
                                    <div className="green bold-text bot5">User</div>
                                    }

                                    {record.By == 'webhook' &&
                                    <div
                                        className="green bold-text bot5">{changeLogWebhookMap[record.Webhook] ? changeLogWebhookMap[record.Webhook] : 'Not available'}</div>
                                    }
                                    {record.OrderID &&
                                    <div>{ 'Order ID:' + record.OrderID}</div>
                                    }
                                    {record.OrderNumber &&
                                    <div>Order Number: { record.OrderNumber}</div>
                                    }
                                    { _.get(record, ['CustomData', 'Type'], false) == 'Reduce' &&
                                    <div>Reduced by: { record.CustomData.Percent + '%'}</div>
                                    }
                                    {record.TransactionID && /* either TransactionID or PayoutNote can exist in a change log object*/
                                    <div>Internal Note: {record.TransactionID}</div>
                                    }
                                    {record.PayoutNote &&
                                    <div>Internal Note: {record.PayoutNote}</div>
                                    }
                                    {record.CustomData &&
                                    <div>Data: {JSON.stringify(_.omit(record.CustomData, ['PaymentRequestID','PayoutRequestID']))}</div>
                                    }
                                    {record.FieldChanged &&
                                    <div>{ record.FieldChanged}</div>
                                    }

                                    {record.From &&
                                    <div>From: {symbol + record.From}</div>
                                    }
                                    {record.To &&
                                    <div>To: {symbol + record.To}</div>
                                    }
                                    {record.Note &&
                                    <div>{ 'Note: ' + record.Note}</div>
                                    }


                                </TimelineEvent>

                            </Timeline>)

                        })}
                    </div>
                    }
                    { _.includes(['ServiceCustomData'], this.state.data.currentField) &&
                    <div>
                        {_.map(records, (value, field) => {
                             if (field == 'ServiceSizeNotes') {
                                return <div className=" bot15" key={field}>
                                     <div className="bold-text bot5">{'User service size notes: '}</div>
                                    <div >{value}</div>
                                    </div>

                            }
                            if (field == 'ContactUserForServiceSize') {
                                return <div className="  bot15" key={field}>
                                    <div ><span  >User selected </span><span className="purple bold-text ">I'd like to make special arrangements for large bulky or heavy items</span><span > checkbox</span></div>

                                </div>

                            }
                        })
                        }
                    </div>
                    }

                    { _.includes(['Comments'], this.state.data.currentField) &&
                    <div>
                        {_.map(records, (item) => {
                              var foundUserRecord =_.find(_.get(this.state.data, 'CommentSentByUserRecords',[]),userData=>{
                                return userData._id == item.SentByUserID
                            })
                                  return <div className=" bot15" key={item.createdAt}>

                                    <div className="bold-text bot5">{ _.get(foundUserRecord,'firstName','') + ' ' +_.get(foundUserRecord,'lastName','') + ' on '+moment(item.createdAt).format('YY/MM/DD')}</div>
                                    <div >{_.get(item,'CommentText')}</div>
                                     {_.get(item, 'CommentImageURL') &&
                                     <div>
                                         <img   width="100" height="100" src={_.get(item, 'CommentImageURL') }/>
                                     </div>
                                     }
                                      {_.get(item, 'CommentTextAsHTML') &&
                                      <div className="comment-as-html">
                                          <div dangerouslySetInnerHTML={{__html: _.get(item,'CommentTextAsHTML')}}></div>

                                      </div>
                                      }

                                          {_.map(_.get(item, 'commentImages', []), (image) => {

                                              return <div className=" bot15" key={image.ShopifyImageID}>
                                                  {_.get(image, 'ShopifyFileURL') &&
                                                  <div>
                                                      <a target="_blank"   href={_.get(image, 'ShopifyFileURL')}><img width="100" height="100"
                                                                                      src={_.get(image, 'ShopifyFileURL') }/></a>
                                                  </div>
                                                  }
                                              </div>
                                          })  }
                                      
                                </div>
                        })
                        }
                    </div>
                    }
                </Modal.Body>

            </Modal>

        );
    }
}
